<template>
  <m-button-theme-provider
    is="button"
    v-bind="props"
    :disabled="disabled || loading"
    :type="type"
    @click="$emit('click')"
  >
    <m-button-icon-container :loading="loading" :icon="icon" :class="gap" class="initial:capitalize">
      <slot />
    </m-button-icon-container>
  </m-button-theme-provider>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import MButtonThemeProvider from './MButtonThemeProvider.vue';
  import MButtonIconContainer from './MButtonIconContainer.vue';
  import type { MButtonProps } from '.';

  export interface Emits {
    (e: 'click'): void;
  }

  const props = withDefaults(defineProps<MButtonProps>(), {
    type: 'button',
    theme: 'primary',
    disabled: false,
    loading: false,
    icon: undefined,
    size: undefined,
    rounded: true,
    iconGap: undefined,
  });

  const gap = computed(() => {
    if (props.iconGap) return props.iconGap;
    else if (props.theme === 'link') return 'gap-1';
    else return 'gap-3';
  });

  defineEmits<Emits>();
</script>
